import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycSpecialNeedsTrustInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-special-needs-trust-in-new-york/']} />;
}
